const SIGNAGE_REFERENCE_WIDTH = 1800

/** Scale preview type against the signage canvas, not the browser window. */
export function canvasFontSize(
  configuredSize: number,
  minimumSize = 8,
  maximumSize = configuredSize
) {
  const safeSize = Math.max(8, Math.min(240, configuredSize))
  const safeMinimum = Math.max(0, minimumSize)
  const safeMaximum = Math.max(safeMinimum, Math.min(240, maximumSize))
  const containerWidthPercent =
    Math.round((safeSize / SIGNAGE_REFERENCE_WIDTH) * 1_000_000) / 10_000

  return `clamp(${safeMinimum}px, ${containerWidthPercent}cqw, ${safeMaximum}px)`
}
